<div class="card border-0 shadow-sm filter-card">
  <div class="card-body p-3">
    <form [formGroup]="formFiltre" (ngSubmit)="onFilter()">
      <div class="row align-items-end">
        <div class="col-md-3 mb-2">
          <label class="filter-label">
            <i class="fas fa-tag mr-1"></i> Type
          </label>
          <select formControlName="type" class="form-control form-control-sm custom-select">
            <option *ngFor="let item of typeRow" [value]="item.value">{{ item?.label }}</option>
          </select>
        </div>
        <div class="col-md-3 mb-2">
          <label class="filter-label">
            <i class="fas fa-filter mr-1"></i> Personnalisation
          </label>
          <select formControlName="personaliseFiltre" class="form-control form-control-sm custom-select">
            <option *ngFor="let item of filtres" [value]="item.value">{{ item?.label }}</option>
          </select>
        </div>
        <div class="col-md-3 mb-2">
          <label class="filter-label">
            <i class="fas fa-at mr-1"></i> Adresse / Numero
          </label>
          <input type="text" class="form-control form-control-sm" formControlName="adresse" placeholder="Rechercher...">
        </div>
        <div class="col-md-2 mb-2">
          <label class="filter-label">
            <i class="fas fa-calendar-alt mr-1"></i> Date
          </label>
          <input type="date" class="form-control form-control-sm" formControlName="mois">
        </div>
        <div class="col-md-1 mb-2">
          <button type="submit" class="btn btn-primary btn-sm btn-block btn-filter">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
